module.exports = __webpack_public_path__ + "aaff2831a4e8114fc0f795799b29db94.jpg";